import {SAddComponentFormValue, SAddComponent} from "@/components/dto/SAddComponentFormValue";
import {SValue} from "@/components/dto/SValue";
import {SValueImpl} from "@/components/dto/SValueImpl";


export class SAddComponentFormValueImpl implements SAddComponentFormValue {
    name: SValue;
    version: SValue;
    component: SValue;
    component_type: SValue;
    component_group: SValue;

    constructor(name: string, version: string, component: string, component_type: string, component_group: string){
        this.name = new SValueImpl(name);
        this.version = new SValueImpl(version);
        this.component = new SValueImpl(component);
        this.component_type = new SValueImpl(component_type);
        this.component_group = new SValueImpl(component_group);
    }

    empty(): SAddComponentFormValue{
        return{
            "name": {
                "value": ''
            },
            "version": {
                "value": ''
            },
            "component": {
                "value": ''
            },
            "component_type": {
                "value": ''
            },
            "component_group": {
                "value": ''
            }
        };
    }
}

export class SAddComponentImpl implements SAddComponent {
    name: string;
    version: string;
    component: string;
    component_type: string;
    component_group: string;

    constructor(addComponent: SAddComponentFormValue){
        this.name = addComponent.name.value;
        this.version = addComponent.version.value;
        this.component = addComponent.component.value;
        this.component_type = addComponent.component_type.value;
        this.component_group = addComponent.component_group.value;
    }

}
